import { Parchment } from 'quill/core';

export default new Parchment.ClassAttributor('diff', 'ql-diff', {
  scope: Parchment.Scope.INLINE_ATTRIBUTE,
  whitelist: ['inserted', 'deleted', 'formatted'],
});
